import { convertMoneyToNumber } from '../util/currency';
import {
  allowDePayPlaceholders,
  getDePayAcceptTokens,
  getDefaultSellerReceiver,
  getTreasuryAddress,
  isDePayReady,
} from '../config/settlementRails';

/** @deprecated use getTreasuryAddress — kept for existing imports */
export const COMPANY_B_TREASURY_ADDRESS =
  getTreasuryAddress() || 'BetterExchangeTreasury1111111111111111111111111';

/** @deprecated use getDefaultSellerReceiver */
export const SELLER_ESCROW_RECEIVER =
  getDefaultSellerReceiver() || 'SellerEscrow111111111111111111111111111111';

export const SOLANA_USDC_MINT = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v';
export const DEPAY_FEE_PERCENT = '0.5%';

/**
 * True when DePay may be opened. Placeholders allowed for initial prod tests
 * unless REACT_APP_DEPAY_ALLOW_PLACEHOLDERS=false.
 */
export const isDePaySettlementConfigured = () => isDePayReady();

export const getEscrowPaymentAmount = (transaction, listing) => {
  const payinTotal = transaction?.attributes?.payinTotal;
  if (payinTotal) {
    const amount = convertMoneyToNumber(payinTotal);
    if (amount > 0) return amount;
  }
  const listingPrice = listing?.attributes?.price;
  if (listingPrice) {
    const amount = convertMoneyToNumber(listingPrice);
    if (amount > 0) return amount;
  }
  return null;
};

/**
 * Opens DePay Payment widget — multi-chain accept list from settlementRails.
 */
export const openDePayEscrowPayment = async ({
  amount,
  receiver,
  onSent,
  onSucceeded,
  onFailed,
}) => {
  if (!isDePayReady()) {
    const err = new Error(
      'DePay not ready — set treasury/seller addresses or REACT_APP_DEPAY_ALLOW_PLACEHOLDERS=true for tests.'
    );
    if (onFailed) onFailed(err);
    throw err;
  }

  if (!allowDePayPlaceholders()) {
    const treasury = getTreasuryAddress();
    const settleTo = receiver || getDefaultSellerReceiver();
    if (!treasury || !settleTo) {
      const err = new Error('Missing DePay receiver addresses');
      if (onFailed) onFailed(err);
      throw err;
    }
  }

  const { default: DePayWidgets } = await import('@depay/widgets');
  const accept = getDePayAcceptTokens({ amount, receiver });

  DePayWidgets.Payment({
    accept,
    sent: transaction => {
      if (onSent) onSent(transaction);
    },
    succeeded: (transaction, payment) => {
      if (onSucceeded) onSucceeded(transaction, payment);
    },
    failed: error => {
      if (onFailed) onFailed(error);
    },
  });
};
